import type { IBracketStore, } from "@store/types";
import { produce } from 'immer';
import type { StateCreator, } from "zustand";
import type { Store } from '../useStore';
import type{ IReferralsSlice, } from "./types";
import { createWalletReferralsSlice, } from "./walletReferralsSlice";
import { createWalletRefIdSlice, } from "./walletRefIdSlice";

export const createReferralsSlice: StateCreator<IBracketStore, [], [], IReferralsSlice> = ( set, get, store, ) => {


	const fetch = async () => {

		set(produce<Store>(state => {
			state.referrals.fetching = true;
		}));


		set(produce<Store>(state => {
			state.ui.ready = true;
			state.ui.fetching = false;
		}));

	}

	const reset = () => {
		console.warn("store:referrals::reset:: not implemented");
	}

	const resetAsync = async () => {
		console.warn("store:referrals::resetAsync:: not implemented");
	}

	setTimeout(_ => fetch(), 0);

	return {
		ready: false,
		fetching: false,
		walletReferrals: createWalletReferralsSlice(set, get, store,),
		walletRefId: createWalletRefIdSlice(set, get, store,),
		fetch,
		reset,
		resetAsync,
	};

};
